import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BidvTransferDestWhitelistService,
  BidvTransferDestWhitelistDeleteEntity,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from '../queries/constants';

export const useDeleteBidvTransferDestWhitelistMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BidvTransferDestWhitelistDeleteEntity, Error, string>({
      mutationFn: (id: string) =>
        BidvTransferDestWhitelistService.bidvTransferDestWhitelistControllerDelete(
          id,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BidvBankTransferServiceKeys.GET_TRANSFER_DEST_WHITELIST],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
